<script lang="ts">
    import type {MessageText} from "./Types";
    import FormattedText from "./FormattedText.svelte";

    export let entity: MessageText
</script>
<FormattedText entity={entity.text}/>
